import "./Courses.css";
import React, { useContext } from "react";
import { MoonLoader } from "react-spinners";
import TextFieldInput from "../../Components/Atoms/Inputs/TextField/TextFieldInput";
import { userContext } from "../../Contexts/userContext";
import { Pagination } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ListIcon from "@mui/icons-material/List";
import Filter from "../../Components/Molecules/Filter/Filter";
import SortButton from "../../Components/Molecules/SortButton/SortButton";

function Courses({
  page,
  searchData,
  search,
  setSearchData,
  setSearch,
  courses,
  navigate,
  handleChangePage,
  loading,
  pageCount,
  setFilter,
  totalCount,
  setSort,
  currentSort,
}) {
  const { contextData } = useContext(userContext);

  // if (loading) {
  //   return (
  //     <div className="mainContainer">
  //       <div className="loadingContainer">
  //         <MoonLoader color="#012369" size={40} />
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="mainContainer">
      {/* Page Header */}
      <div className="pageHeader">
        <div className="pageTitle">
          <div className="titleIcon">
            <MenuBookIcon />
          </div>
          <div className="titleContent">
            <h1>Programs Management</h1>
            <p>Manage and view all educational programs</p>
          </div>
        </div>

        {contextData?.role === "admin" && (
          <button
            className="actionButton primary addButton"
            onClick={() => navigate("/programs/add")}
          >
            <AddIcon />
            Add Program
          </button>
        )}
      </div>

      {loading ? (
        ""
      ) : (
        <>
          {/* Statistics Cards */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <MenuBookIcon />
              </div>
              <div className="statContent">
                <h4>Total Programs</h4>
                <h2>{totalCount || 0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon success">
                <DescriptionIcon />
              </div>
              <div className="statContent">
                <h4>Active Programs</h4>
                <h2>{0}</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon warning">
                <ListIcon />
              </div>
              <div className="statContent">
                <h4>Total Standards</h4>
                <h2>{0}</h2>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Programs Cards */}
      <div className="contentSection">
        <div className="tableHeader">
          <h2 className="sectionTitle">Programs List</h2>
        </div>

        <div className="searchFilterHeader">
          <div className="searchFilterGroup">
            <TextFieldInput
              searchIcon={true}
              Required={false}
              type="text"
              placeholder={"Search programs..."}
              className="modernSearchBar"
              name={"search"}
              change={(e) => setSearchData(e.target.value)}
              newValue={searchData}
              searchAction={() => {
                if (search !== searchData) {
                  setSearch(searchData);
                }
              }}
              keyDown={(e) => {
                if (e.keyCode === 13) {
                  if (search !== searchData) {
                    setSearch(searchData);
                  }
                }
              }}
            />
            <Filter schools setFilter={setFilter} />
            <SortButton
              setSort={setSort}
              currentSort={currentSort}
              title
              createdAt
            />
          </div>
        </div>

        {loading ? (
          ""
        ) : (
          <>
            <div className="tableHeaderCount">
              <div className="tableActions">
                <span className="resultsCount">
                  Showing {courses?.length || 0} programs
                </span>
              </div>
            </div>
          </>
        )}

        {loading ? (
          <div className="loadingContainer">
            <MoonLoader color="#012369" size={40} />
          </div>
        ) : (
          <>
            {courses && courses.length > 0 ? (
              <div className="coursesGrid">
                {courses.map((course) => (
                  <div
                    key={course.id}
                    className="courseCard"
                    onClick={() => navigate(`/programs/${course.id}`)}
                  >
                    <div
                      className="courseHeader"
                      style={{ marginBottom: "12px" }}
                    >
                      <div className="courseIcon">
                        <MenuBookIcon />
                      </div>
                      <h3 className="courseTitle">{course?.title}</h3>
                    </div>

                    <div className="courseContent">
                      <div className="courseDescription">
                        <DescriptionIcon className="descriptionIcon" />
                        <p>
                          {course?.description || "No description available"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <div className="emptyIcon">
                  <MenuBookIcon />
                </div>
                <h3>No Programs Found</h3>
                <p>
                  No programs have been added yet. Start by adding your first
                  program.
                </p>
                {contextData?.role === "admin" && (
                  <button
                    className="actionButton primary"
                    onClick={() => navigate("/programs/add")}
                    style={{ margin: "20px auto" }}
                  >
                    <AddIcon />
                    Add First Program
                  </button>
                )}
              </div>
            )}
          </>
        )}

        {loading ? (
          ""
        ) : (
          <>
            {/* Pagination */}
            {courses && courses.length > 0 && (
              <div className="paginationContainer">
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={handleChangePage}
                  size="large"
                  color="primary"
                  className="paginationCount"
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Courses;
